import React from 'react';
import Institute_Master from './Institute_Master';
import '../../CommonCSS/SocietyCSS.css';

const InstituteApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Institute Master </h5>
          </div>
        </div>
        <Institute_Master />
      </div>
    </div >
  );
};

export default InstituteApp;
